/**
 * Centralized UTC timestamp helpers for all mock, seed, demo, and UI-only data.
 * Use these instead of hardcoded ISO timestamps in examples or generated fixtures.
 */

export const utcNow = () => new Date();

export const nowIsoUtc = () => utcNow().toISOString();

export const nowStampUtc = () => nowIsoUtc().replace(/[:.]/g, "-").slice(0, 19);

export const safeIsoUtc = (value = utcNow()) => {
  if (value == null) return nowIsoUtc();
  if (typeof value === "string") {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? nowIsoUtc() : parsed.toISOString();
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? nowIsoUtc() : date.toISOString();
};

export const mockTimestamp = (date = utcNow()) => safeIsoUtc(date);

export const mockTimeOffset = (offsetMs = 0) =>
  new Date(utcNow().getTime() + offsetMs).toISOString();

export const withCurrentTime = (record = {}, fields = ["timestamp", "created_at", "updated_at", "generated_at", "exported_at", "event_time"]) => {
  const stamp = nowIsoUtc();
  const next = { ...record };
  for (const field of fields) {
    if (next[field] == null) next[field] = stamp;
  }
  return next;
};

export const makeMockRecord = (overrides = {}, base = {}, fields = ["created_at", "updated_at"]) => {
  const createdAt = nowIsoUtc();
  const record = withCurrentTime({
    [fields[0]]: createdAt,
    [fields[1] ?? fields[0]]: createdAt,
    ...base,
    ...overrides,
  }, fields);
  return {
    ...record,
    [fields[0]]: record[fields[0]] ?? createdAt,
    [fields[1] ?? fields[0]]: record[fields[1] ?? fields[0]] ?? createdAt,
  };
};
